module.exports = __webpack_public_path__ + "static/img/g_bib.3b6debb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/g_bib.png
// module id = nyMD
// module chunks = 1